import { createAction, handleActions } from 'redux-actions';
import { createRequestActionTypes } from '../../lib/createRequestSaga';
import { takeLatest, call, put } from 'redux-saga/effects';
import { startLoading, finishLoading } from '../loading';

import * as inventoryApi from '../../lib/api/inventory';


const [LIST_INV_STOCKS, LIST_INV_STOCKS_SUCCESS, LIST_INV_STOCKS_FAILURE] =
    createRequestActionTypes('inventory/LIST_INV_STOCKS');

// payload: { whUuid, ...searchParams }
export const listInventoryStocks = createAction(
    LIST_INV_STOCKS,
    (payload) => payload,
);

function* listInventoryStocksSaga(action) {
    yield put(startLoading(LIST_INV_STOCKS));
    try {
        const { whUuid, ...searchParams } = action.payload || {};
        const whId = whUuid || inventoryApi.whUuid; // fallback to default
        const response = yield call(inventoryApi.getInventoryStocks, whId, searchParams);
        yield put({
            type: LIST_INV_STOCKS_SUCCESS,
            payload: response.data,
        });
    } catch (e) {
        console.log(e, LIST_INV_STOCKS);
        yield put({
            type: LIST_INV_STOCKS_FAILURE,
            payload: e,
            error: true,
        });
    }
    yield put(finishLoading(LIST_INV_STOCKS));
}

const UNLOAD_INV_STOCKS = 'inventory/UNLOAD_INV_STOCKS';
export const unloadInventoryStocks = createAction(UNLOAD_INV_STOCKS);

export function* invStocksSaga() {
    yield takeLatest(LIST_INV_STOCKS, listInventoryStocksSaga);
}

const initialState = {
    stocks: null,
    error: null,
};

const invStocks = handleActions(
    {

        [LIST_INV_STOCKS_SUCCESS]: (state, { payload: data }) => ({
            ...state,
            stocks: data.list.map((stock) => ({
                id: stock.stockUuid,
                stockUuid: stock.stockUuid,
                whUuid: stock.whUuid,
                productUuid: stock.productUuid,
                productNm: stock.productNm,
                category: stock.category,
                modelNm: stock.modelNm,
                masPartnerNm: stock.masPartnerNm,//제조업체
                pricePartnerNm: stock.pricePartnerNm,//매입처(구매처)
                trnUuid: stock.trnUuid,
                trnDesc: stock.trnDesc,
                priceUuid: stock.priceUuid,
                productCnt: stock.productCnt,
                priceVal: stock.priceVal,
                crtUsrNm: stock.crtUsrNm,
                crtDt: stock.crtDt,
            })),
            error: null,
        }),
        [LIST_INV_STOCKS_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error: error,
        }),
        [UNLOAD_INV_STOCKS]: () => initialState
    },
    initialState,
);

export default invStocks;
